// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'common/stylus/base.styl'
import Toasted from 'vue-toasted'
import VueClipboard from 'vue-clipboard2'
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto'
import VueI18n from 'vue-i18n'
import LangEn from 'common/lang/en'
import LangZhCN from 'common/lang/zh_CN'
import LangZhTW from 'common/lang/zh_TW'
import LangRu from 'common/lang/ru'
import Validate from 'common/script/validate'
import czurUI from 'common/script/index'
import VueResource from 'vue-resource'
Vue.use(czurUI)
Vue.use(VueResource)

Vue.config.productionTip = false
Vue.use(Toasted, {
  theme: 'toasted-primary',
  position: 'bottom-center',
  duration: 3000
})
Vue.use(VueClipboard)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 3,
  listenEvents: [ 'scroll' ]
})

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.directive('scroll', {
  inserted: function (el, binding) {
    var cb = binding.value
    el.addEventListener('mousewheel', function (event) {
      cb(event)
    })
  }
})

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  },
  update: function (el, binding) {
    document.title = el.dataset.title
  }
})

// Vue.directive('scrollfox', {
//   inserted: function (el, binding) {
//     var cb = binding.value
//     el.addEventListener('DOMMouseScroll', function (event) {
//       cb(event)
//     })
//   }
// })

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en', // 语言标识
  messages: {
    'en': LangEn,
    'zh-CN': LangZhCN,
    'zh-TW': LangZhTW,
    'ru_RU': LangRu
  }
})
// 检测浏览器语言
var currentLang = Validate.lang()
setI18nLanguage(currentLang)
function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang) // 根元素增加lang属性
  return lang
}

// vue router config
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js